"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiers = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_modifiers_1 = require("styled-components-modifiers");

var styled_components_1 = require("styled-components");

var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");

var Title_styled_1 = require("./Title.styled");

Object.defineProperty(exports, "modifiers", {
  enumerable: true,
  get: function get() {
    return Title_styled_1.modifiers;
  }
});

var Title = function Title(_ref) {
  var as = _ref.as,
      children = _ref.children,
      content = _ref.content,
      modifiers = _ref.modifiers,
      size = _ref.size,
      isHTML = _ref.isHTML,
      dataNw = _ref.dataNw,
      className = _ref.className;

  if (isHTML) {
    return react_1.default.createElement(Title_styled_1.TitleStyled, {
      modifiers: modifiers,
      as: as,
      size: size,
      dangerouslySetInnerHTML: {
        __html: content
      }
    });
  }

  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(Title_styled_1.TitleStyled, {
    className: className,
    modifiers: modifiers,
    as: as,
    size: size,
    "data-nw": dataNw
  }, children || content));
};

Title.propTypes = {
  as: prop_types_1.default.string,
  children: prop_types_1.default.node,
  content: prop_types_1.default.node,
  modifiers: (0, styled_components_modifiers_1.styleModifierPropTypes)(Title_styled_1.modifiers),
  size: prop_types_1.default.string,
  isHTML: prop_types_1.default.bool,
  dataNw: prop_types_1.default.string,
  className: prop_types_1.default.string
};
Title.defaultProps = {
  as: '',
  children: null,
  content: '',
  isHTML: false,
  dataNw: null
};
exports.default = Title;